import React from 'react';
import { FilterType } from '../types/Task';

interface FilterButtonsProps {
  currentFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  counts: {
    total: number;
    active: number;
    completed: number;
  };
}

const FilterButtons: React.FC<FilterButtonsProps> = ({ 
  currentFilter, 
  onFilterChange, 
  counts 
}) => {
  const filters: { value: FilterType; label: string; count: number }[] = [
    { value: 'all', label: 'All Tasks', count: counts.total },
    { value: 'active', label: 'Active', count: counts.active },
    { value: 'completed', label: 'Completed', count: counts.completed },
  ];

  return (
    <div className="filter-container">
      {filters.map((filter) => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          className={`filter-btn ${currentFilter === filter.value ? 'active' : ''}`}
        >
          <span>{filter.label}</span>
          <span className="filter-badge">{filter.count}</span>
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;